<script>
import {  state } from "../Store/StateStore"

import { config } from "../Store/ConfigStore"
import{context} from "../Store/ContextStore";
import { onDestroy, onMount } from "svelte"
import { fade, fly } from 'svelte/transition'

import LocationList from "./LocationList.svelte";

const page_title = $context.page_title
const eyebrow = $context.page_eyebrow
export let locations = []

// fns
onDestroy( () => {
	state.hideOverlay()
} )

onMount( () => {
	console.log( 'locations', $config.locations )

	if ( $config.debug ) {
		console.log( { $context } )
	}
} )
</script>


<div class="cul-overlay__outer">

	<div class="cul-overlay__bg" on:click={state.hideOverlay} transition:fade>
	</div>

	<div class="cul-overlay__inner" transition:fly={{ x: 100 }}>
		<div class="cul-overlay__header" in:fade>
			<div class="cul-overlay__eyebrow">{ eyebrow }</div>

			<div class="cul-overlay__title">{ page_title }</div>

			<button type="button" on:click={state.hideOverlay}>
				<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M4.40234 6.69927L6.28984 4.81177L27.5973 26.1193L25.7098 28.0068L4.40234 6.69927Z" fill="#262727"/>
					<path d="M4.40234 26.1193L25.7098 4.81177L27.5973 6.69927L6.28984 28.0068L4.40234 26.1193Z" fill="#262727"/>
				</svg>
			</button>
		</div>

		<div class="cul-overlay__content" in:fly={{ y: -15, delay: 100}}>
			<LocationList {locations}/>
		</div>

		<div class="cul-overlay__footer" in:fade>
		</div>
	</div>
</div>
